"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentModelJsonMapper = exports.ContentModelDynamoMapper = void 0;
var content_model_dynamodb_1 = require("./content-model-dynamodb");
Object.defineProperty(exports, "ContentModelDynamoMapper", { enumerable: true, get: function () { return content_model_dynamodb_1.ContentModelDynamoMapper; } });
var content_model_json_1 = require("./content-model-json");
Object.defineProperty(exports, "ContentModelJsonMapper", { enumerable: true, get: function () { return content_model_json_1.ContentModelJsonMapper; } });
